export const PROJECT_CONFIG_SESSION_STORAGE_KEY = 'twc-land-onboarding-project-config';
